import { z } from 'zod'

const roleEnum = z.enum(
  ['OPERATIONAL', 'ADMINISTRATIVE', 'FINANCIAL', 'MANAGEMENT', 'OTHER'],
  { error: 'Cargo obrigatório' },
)

export const employeeSchema = z.object({
  name: z.string().min(1, 'Nome obrigatório').max(100),
  cpf: z.string().regex(/^\d{11}$/, 'CPF deve ter 11 dígitos'),
  role: roleEnum,
  hireDate: z.string().min(1, 'Data de admissão obrigatória'),
  baseSalary: z.coerce
    .number({ error: 'Salário inválido' })
    .positive('Salário base deve ser positivo'),
  paymentDay: z.coerce
    .number({ error: 'Dia inválido' })
    .int()
    .min(1, 'Dia mínimo é 1')
    .max(31, 'Dia máximo é 31'),

  email: z.email('Email inválido').optional().or(z.literal('')),
  phone: z.string().regex(/^\d{10,11}$/, 'Telefone inválido').optional().or(z.literal('')),

  bankName: z.string().max(80).optional().or(z.literal('')),
  bankAgency: z.string().max(20).optional().or(z.literal('')),
  bankAccount: z.string().max(30).optional().or(z.literal('')),
  bankAccountType: z.enum(['corrente', 'poupanca']).optional().or(z.literal('')),
  pixKey: z.string().max(150).optional().or(z.literal('')),
})

export type EmployeeFormData = z.infer<typeof employeeSchema>

export const salaryPaymentSchema = z.object({
  referenceMonth: z.coerce
    .number({ error: 'Mês inválido' })
    .int()
    .min(1, 'Mês de referência entre 1 e 12')
    .max(12, 'Mês de referência entre 1 e 12'),
  referenceYear: z.coerce
    .number({ error: 'Ano inválido' })
    .int()
    .min(2000, 'Ano inválido')
    .max(2100, 'Ano inválido'),
  amount: z.coerce
    .number({ error: 'Valor inválido' })
    .positive('Valor deve ser positivo'),
  paymentDate: z.string().min(1, 'Data obrigatória'),
  method: z.enum(['PIX', 'BANK_TRANSFER', 'BANK_SLIP', 'CASH', 'OTHER']),
  notes: z.string().optional(),
  accountId: z.string().min(1, 'Conta obrigatória'),
})

export type SalaryPaymentFormData = z.infer<typeof salaryPaymentSchema>
